window.dropdowns = [
    'mini-cart',
    'search-results',
    'product-filters',
    'nav-categories'
];
window.searchInputBreakpoint = 992;